var NahmSpirit = NahmSpirit || {};

NahmSpirit.HeroSwiper = function() {

    var _initialized = false;
    var _swipers = [];

    var _selectors = {
        swiper: '.swiper.swiper--hero'
    };

    var _defaults = {
        slides: {xs: 1, sm: 1, md: 1.33, lg: 2.33, xl: 2.33, xxl: 2.33},
        spacing: {xs: 20, sm: 20, md: 20, lg: 20, xl: 20, xxl: 20}
    };

    var _init = function() {
        $(_selectors.swiper).each(function() {
            let el = $(this);

            let breakpoints = {
                0: {slidesPerView: el.data('xs-slides') || el.data('slides') || _defaults.slides.xs, spaceBetween: el.data('xs-spacing') || el.data('spacing') || _defaults.spacing.xs},
                576: {slidesPerView: el.data('sm-slides') || el.data('slides') || _defaults.slides.sm, spaceBetween: el.data('sm-spacing') || el.data('spacing') || _defaults.spacing.sm},
                768: {slidesPerView: el.data('md-slides') || el.data('slides') || _defaults.slides.md, spaceBetween: el.data('md-spacing') || el.data('spacing') || _defaults.spacing.md},
                992: {slidesPerView: el.data('lg-slides') || el.data('slides') || _defaults.slides.lg, spaceBetween: el.data('lg-spacing') || el.data('spacing') || _defaults.spacing.lg},
                1200: {slidesPerView: el.data('xl-slides') || el.data('slides') || _defaults.slides.xl, spaceBetween: el.data('xl-spacing') || el.data('spacing') || _defaults.spacing.xl},
                1400: {slidesPerView: el.data('xxl-slides') || el.data('slides') || _defaults.slides.xxl, spaceBetween: el.data('xxl-spacing') || el.data('spacing') || _defaults.spacing.xxl}
            };

            let swiper = new Swiper(el[0], {
                loop: true,
                autoplay: {
									disableOnInteraction: false,
									// pauseOnMouseEnter: true
								},
                // slidesPerView: 1,
                // spaceBetween: 20,
                // pagination: {
                //     el: el.parent().find('.swiper-pagination--reviews')[0],
                //     clickable: true,
                //     type: 'bullets',
                // },
                breakpoints: breakpoints,

            });

            _swipers.push(swiper);
        });

        if (!_initialized) {
            _initialized = true;
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();}
    };

}();

$(function() {
	NahmSpirit.HeroSwiper.init();
});
